let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5K06i"), load("amAvE")]).then(() => parcelRequire('eiQQV'));